import { Divider } from "@mui/material";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import { Link as GatsbyLink } from "gatsby";
import React from "react";
import FeatureRow from "../../../components/FeatureRow";
import SectionTitle from "../../../components/layout/SectionTitle";
import {
  ABSENCES_FEATURES_SECTION,
  ABSENCES_FEATURE_SALARIES,
  ABSENCES_FEATURE_MANAGERS,
  ABSENCES_FEATURE_GESTIONNAIRES,
  ABSENCES_FEATURE_PARAMETRAGE,
} from "../../../util/constants";
import { classes, StyledSectionWrapper } from "./styles";

const AgendaFeatures = () => {
  return (
    <StyledSectionWrapper sectionId={ABSENCES_FEATURES_SECTION}>
      <Container className={classes.container}>
        <SectionTitle text="Fonctionnalités" variant="innoGrey" />
        <FeatureRow
          product="ABSENCES"
          id={ABSENCES_FEATURE_SALARIES}
          title="Pour les salariés"
          text=""
          imgSrc="/images/absences/innovance-solutions-absences-pour-les-salaries.svg"
          imgWidth="811"
          imgHeight="696"
          bullets={[
            "Création et soumission intuitives des demandes d'absences",
            "Envoi d'un email de notification dès qu'une demande est validée ou rejetée",
            "Affichage des demandes validées dans l'agenda",
            "Consultation des compteurs personnels de congés payés, jours de RTT, congés exceptionnels pour connaitre le solde en temps réel",
            "Consultation du volume d’heures travaillées et/ou à récupérer",
          ]}
        />
        <Divider />
        <FeatureRow
          product="ABSENCES"
          id={ABSENCES_FEATURE_MANAGERS}
          direction="row-reverse"
          title="Pour les managers"
          text=""
          imgSrc="/images/absences/innovance-solutions-absences-pour-les-managers.svg"
          imgWidth="580"
          imgHeight="564"
          bullets={[
            "Visualisation des demandes de l’équipe dans un calendrier synthétique couvrant jusqu'à 8 semaines consécutives",
            "Validation ou rejet de la demande d’un simple clic",
            "Visualisation du nombre de demandes restant à valider dans l’application",
            "Accès aux compteurs des subordonnés pour consulter les soldes en temps réel",
          ]}
        />
        <Divider />
        <FeatureRow
          product="ABSENCES"
          id={ABSENCES_FEATURE_GESTIONNAIRES}
          title="Pour les gestionnaires"
          text=""
          imgSrc="/images/absences/innovance-solutions-absences-pour-les-gestionnaires.svg"
          imgWidth="884"
          imgHeight="478"
          bullets={[
            "Vision globale des demandes d’absences et des compteurs de l’ensemble des salariés",
            "Possibilité de créer et valider des demandes d’absences dans le passé pour n’importe quel salarié",
            "Régularisation manuelle des compteurs pour les besoins spécifiques (initialisation, fractionnement, arrondis…)",
            "Export mensuel des absences validées pour la préparation de la paie",
            "Calcul automatique des majorations hebdomadaires ou périodiques et des compensations",
            "Impression mensuelle de fiches temps pour signature par les salariés et leurs responsables",
          ]}
        />
        <Divider />
        <FeatureRow
          product="ABSENCES"
          id={ABSENCES_FEATURE_PARAMETRAGE}
          direction="row-reverse"
          title="Les possibilités de paramétrage"
          text=""
          imgSrc="/images/absences/innovance-solutions-absences-parametrage.svg"
          imgWidth="890"
          imgHeight="490"
          bullets={[
            "Création de motifs d'absences à la journée ou à la demi-journée, sur la base des catégories et natures utilisées dans Innovance Agenda",
            "Motifs d’absences avec gestion de compteurs (acquisitions et décomptes automatiques)",
            "Options d’affichage des demandes d’absences dans les agendas (catégorie, nature, statuts affichés)",
            "Création des horaires de travail pour tous les types de contrats (temps plein, temps partiel, forfait jours) et visualisation des horaires dans les agendas",
            "Application des limites réglementaires (en option)",
            "Gestion centralisée des jours fériés",
            "Profils de récupérations avec règles de calculs personnalisées",
            "Modèles de fiches temps mensuelles avec colonnes personnalisables",
          ]}
        />
        <Divider />
      </Container>
    </StyledSectionWrapper>
  );
};

export default AgendaFeatures;
